import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { openModal } from "risa-oasis-ui_v2";
import ImageviewerModal from "../../../components/modals/imageViewerModal/imageviewerModal";
import ImageViewerWithBadgesModal from "../../../components/modals/imageViewerWithBadgesModal/imageViewerWithBadgesModal";
import { LocalStorageKeys } from "../../../enums/localStorageKeys";
import { ModalId } from "../../../enums/modalId";
import { closeModal } from "../../../redux/slice/modalSlice";
import { AppDispatch, RootState } from "../../../redux/store/store";
import { setItemInLocalStorage } from "../../../utils/localStorageHelper";
import { capitalizeWordsSeperatedByUnderScore } from "../../../utils/stringModifications";
import { swapUnderscoreHyphen } from "../../../utils/swapUnderscoreWithHypen";
import GenericAuthStatusOrdersTable from "./components/genericAuthStatusOrdersTable";

const GenericAuthStatusOrders = () => {
  const { tabId } = useParams<{ tabId: string }>();
  const { openedModalId, metaData } = useSelector(
    (state: RootState) => state.modal,
  );
  const dispatch = useDispatch<AppDispatch>();
  const genericAuthStatusOrdersTableRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (openedModalId === ModalId.IMAGE_VIEWER_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_MODAL);
    }
    if (openedModalId === ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL);
    }
  }, [openedModalId]);

  useEffect(() => {
    setItemInLocalStorage(LocalStorageKeys.PARENT_TABLE, tabId ?? "");
  }, [tabId]);

  return (
    <div className="generic-auth-status-orders--main-container flex h-full flex-col overflow-hidden">
      <div className="generic-auth-status-orders__header mb-4 text-h11 font-bold text-primaryGray-1">
        {capitalizeWordsSeperatedByUnderScore(
          swapUnderscoreHyphen(tabId ?? ""),
        )}
        {" -- "}
        PA Orders
      </div>
      <div className="generic-auth-status-orders__table-container flex-1 overflow-auto">
        <GenericAuthStatusOrdersTable
          genericAuthStatusOrdersTableRef={genericAuthStatusOrdersTableRef}
          tabId={swapUnderscoreHyphen(tabId ?? "")}
        />
      </div>

      <>
        {openedModalId === ModalId.IMAGE_VIEWER_MODAL && (
          <ImageviewerModal
            fileUrls={metaData?.fileUrls ?? []}
            filePaths={metaData?.filePaths ?? []}
            onClose={() => dispatch(closeModal())}
          />
        )}
        {openedModalId === ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL && (
          <ImageViewerWithBadgesModal
            tabs={metaData?.tabs ?? []}
            showLoading={metaData?.showLoading ?? false}
            title="Write Back Trail"
          />
        )}
      </>
    </div>
  );
};

export default GenericAuthStatusOrders;
